export default __webpack_public_path__ + "static/media/logo.ef01249c.png";